/**
 * FORMAT CURRENCY
 * @type {Intl.NumberFormat}
 */
var formater = Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
});

/**
 * POPUP BUTTONS
 */
$("[data-popup]").click(function (e) {
    e.preventDefault();
    var data = $(this).data();

    // title
    $(".modal_title_" + data.popup_size).html(data.popup_title);

    // content
    if (data.popup == 'special') {
        $.post(url("/ingresso/especial"), function (response) {
            $(".modal_content_" + data.popup_size).html(response);
        });
    } else {
        $(".modal_content_" + data.popup_size).html(data.popup_description);
    }

    // open
    openModal("#modal_" + data.popup_size);
});


/**
 * LOADER
 */
function loaderShow() {
    loader.fadeIn(200);
}
function loaderClose() {
    loader.fadeOut(200);
}

//data- loader
$('body').on('click', '[data-loader]', function (e) {
    loader.fadeIn(200);
});
